import axios from 'axios';
const BASE_URL = 'https://inventariosbackend.velasresorts.com/inventarios/sublineas';

export interface Sublinea {
    id_sub: number;
    nom_sub: string;
    num_sub: string;
    id_linea: number;
    nom_linea: string;
    num_linea: string;
}

const sublineasApi = {
    listado: async (): Promise<Sublinea[]> => {
        try {
            const response = await axios.get(`${BASE_URL}/listado`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
            return Array.isArray(response.data) ? response.data : [];
        } catch (error) {
            console.error('Error fetching sublineas:', error);
            return [];
        }
    },
};

export default sublineasApi;
